var _g, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbstractDesignIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 30,
    viewBox: "0 0 69 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_431_587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 30.0165C23.2843 30.0165 30 23.3008 30 15.0165C30 6.73225 23.2843 0.0166016 15 0.0166016C6.71573 0.0166016 0 6.73225 0 15.0165C0 23.3008 6.71573 30.0165 15 30.0165Z",
    fill: "#293543"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 45C8.28427 45 15 38.2843 15 30C15 21.7157 8.28427 15 0 15C-8.28427 15 -15 21.7157 -15 30C-15 38.2843 -8.28427 45 0 45Z",
    fill: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 45C38.2843 45 45 38.2843 45 30C45 21.7157 38.2843 15 30 15C21.7157 15 15 21.7157 15 30C15 38.2843 21.7157 45 30 45Z",
    fill: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 15C8.28427 15 15 8.28427 15 0C15 -8.28427 8.28427 -15 0 -15C-8.28427 -15 -15 -8.28427 -15 0C-15 8.28427 -8.28427 15 0 15Z",
    fill: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 15C38.2843 15 45 8.28427 45 0C45 -8.28427 38.2843 -15 30 -15C21.7157 -15 15 -8.28427 15 0C15 8.28427 21.7157 15 30 15Z",
    fill: "#F2CB6F"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_431_587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 24.0097C49.9706 24.0097 54 19.9803 54 15.0097C54 10.0392 49.9706 6.00977 45 6.00977C40.0294 6.00977 36 10.0392 36 15.0097C36 19.9803 40.0294 24.0097 45 24.0097Z",
    fill: "#1F2A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 33C40.9706 33 45 28.9706 45 24C45 19.0294 40.9706 15 36 15C31.0294 15 27 19.0294 27 24C27 28.9706 31.0294 33 36 33Z",
    fill: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 33C58.9706 33 63 28.9706 63 24C63 19.0294 58.9706 15 54 15C49.0294 15 45 19.0294 45 24C45 28.9706 49.0294 33 54 33Z",
    fill: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 15C40.9706 15 45 10.9706 45 6C45 1.02944 40.9706 -3 36 -3C31.0294 -3 27 1.02944 27 6C27 10.9706 31.0294 15 36 15Z",
    fill: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 15C58.9706 15 63 10.9706 63 6C63 1.02944 58.9706 -3 54 -3C49.0294 -3 45 1.02944 45 6C45 10.9706 49.0294 15 54 15Z",
    fill: "#F2CB6F"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_431_587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.2 19.2047C66.5196 19.2047 68.4 17.3243 68.4 15.0047C68.4 12.6851 66.5196 10.8047 64.2 10.8047C61.8804 10.8047 60 12.6851 60 15.0047C60 17.3243 61.8804 19.2047 64.2 19.2047Z",
    fill: "#1F2A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9998 23.4C62.3194 23.4 64.1998 21.5196 64.1998 19.2C64.1998 16.8804 62.3194 15 59.9998 15C57.6802 15 55.7998 16.8804 55.7998 19.2C55.7998 21.5196 57.6802 23.4 59.9998 23.4Z",
    fill: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3997 23.4C70.7193 23.4 72.5997 21.5196 72.5997 19.2C72.5997 16.8804 70.7193 15 68.3997 15C66.0801 15 64.1997 16.8804 64.1997 19.2C64.1997 21.5196 66.0801 23.4 68.3997 23.4Z",
    fill: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9998 14.9996C62.3194 14.9996 64.1998 13.1192 64.1998 10.7996C64.1998 8.48001 62.3194 6.59961 59.9998 6.59961C57.6802 6.59961 55.7998 8.48001 55.7998 10.7996C55.7998 13.1192 57.6802 14.9996 59.9998 14.9996Z",
    fill: "#F2CB6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.3997 14.9996C70.7193 14.9996 72.5997 13.1192 72.5997 10.7996C72.5997 8.48001 70.7193 6.59961 68.3997 6.59961C66.0801 6.59961 64.1997 8.48001 64.1997 10.7996C64.1997 13.1192 66.0801 14.9996 68.3997 14.9996Z",
    fill: "#F2CB6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_431_587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_431_587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(36 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_431_587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.4,
    height: 8.4,
    fill: "white",
    transform: "translate(60 10.7998)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbstractDesignIcon);
export default __webpack_public_path__ + "static/media/AbstractDesignIcon.926aad7ced1d9ddde7cf8d1e2cac2e60.svg";
export { ForwardRef as ReactComponent };